var AutoRoutingBuilder = /** @class */ (function () {
    function AutoRoutingBuilder() {
        var defaultChannelSettings = {
            enabled: true,
            maxWorkload: 3,
            maxSecondsToAccept: 25
        };
        var autoRoutingSettings = {
            ticketing: defaultChannelSettings,
            chat: defaultChannelSettings,
            whatsapp: defaultChannelSettings,
            facebook: defaultChannelSettings,
            sms: defaultChannelSettings,
            twitter: defaultChannelSettings,
            instagram: defaultChannelSettings,
            groupIds: []
        };
        var autoRoutingSupportedSettings = {
            autoRouting: autoRoutingSettings,
            callCenterSupported: true,
            knowledgebaseSupported: true,
            chatSupported: true,
            facebookSupported: true,
            ticketingSupported: true,
            whatsappSupported: true,
            smsSupported: true,
            twitterSupported: true,
            instagramSupported: true,
        };
        this.autoRoutingSettings = autoRoutingSupportedSettings;
    }
    AutoRoutingBuilder.prototype.withTicketingSettings = function (settings) {
        this.autoRoutingSettings.autoRouting.ticketing = settings;
        return this;
    };
    AutoRoutingBuilder.prototype.withChatSettings = function (settings) {
        this.autoRoutingSettings.autoRouting.chat = settings;
        return this;
    };
    AutoRoutingBuilder.prototype.withWhatsappSettings = function (settings) {
        this.autoRoutingSettings.autoRouting.whatsapp = settings;
        return this;
    };
    AutoRoutingBuilder.prototype.withFacebookSettings = function (settings) {
        this.autoRoutingSettings.autoRouting.facebook = settings;
        return this;
    };
    AutoRoutingBuilder.prototype.withTwitterSettings = function (settings) {
        this.autoRoutingSettings.autoRouting.twitter = settings;
        return this;
    };
    AutoRoutingBuilder.prototype.withGroupIds = function (groupIds) {
        this.autoRoutingSettings.autoRouting.groupIds = groupIds;
        return this;
    };
    AutoRoutingBuilder.prototype.withChatSupported = function (chatSupported) {
        this.autoRoutingSettings.chatSupported = chatSupported;
        return this;
    };
    AutoRoutingBuilder.prototype.withTicketingSupported = function (ticketingSupported) {
        this.autoRoutingSettings.ticketingSupported = ticketingSupported;
        return this;
    };
    AutoRoutingBuilder.prototype.withWhatsappSupported = function (whatsappSupported) {
        this.autoRoutingSettings.whatsappSupported = whatsappSupported;
        return this;
    };
    AutoRoutingBuilder.prototype.withFacebookSupported = function (facebookSupported) {
        this.autoRoutingSettings.facebookSupported = facebookSupported;
        return this;
    };
    AutoRoutingBuilder.prototype.withTwitterSupported = function (twitterSupported) {
        this.autoRoutingSettings.twitterSupported = twitterSupported;
        return this;
    };
    AutoRoutingBuilder.prototype.build = function () {
        return this.autoRoutingSettings;
    };
    return AutoRoutingBuilder;
}());
export { AutoRoutingBuilder };
//# sourceMappingURL=builders.js.map